import ErrorTooltip from './ErrorTooltip';

export default ErrorTooltip;
